import { render, staticRenderFns } from "./ListPlatformTypeView.vue?vue&type=template&id=62734718"
import script from "./ListPlatformTypeView.vue?vue&type=script&lang=ts"
export * from "./ListPlatformTypeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports